import React from "react";
import { APPOINTMENT_URL } from "./url/url";

export default function Appointment() {
  return (
    <iframe
      title="Appointment Page"
      src={APPOINTMENT_URL}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        border: "none",
      }}
    />
  );
}
